import { AxiosRequestConfig } from "axios";
import { CohesiveAPIClient } from "../../client";
import { route } from "../../utils";
import { GenaiRequest, GenaiResponse, GenaiResponseData } from "./types";

export * from "./types";

const ENDPOINTS = {
  GENAI: "/api/v2/org/:organization_id/user/:user_id/genai",
};

/**
 * GenaiAPI handles AI text generation requests.
 */
export class GenaiAPI {
  constructor(private client: CohesiveAPIClient) {}

  /**
   * Generate AI completion for the given input text.
   * Optionally provide an output schema for structured JSON output.
   * @param data - The genai request payload
   * @param config - Optional axios config
   * @returns The genai response data
   */
  async generate(
    data: GenaiRequest,
    config?: AxiosRequestConfig,
  ): Promise<GenaiResponseData> {
    const organizationId = await this.client.getOrgID();
    const userId = await this.client.getUserID();
    const response = await this.client.axios.post<GenaiResponse>(
      route(ENDPOINTS.GENAI, {
        organization_id: organizationId,
        user_id: userId,
      }),
      data,
      config,
    );
    return response.data.data;
  }
}
